import {createContext} from 'react';
import defaultConfig from 'src/internal/config/defaultConfig';

import type {IntlConfig} from 'src/types';

export default createContext<IntlConfig>(defaultConfig);
